<div class="page gray-font-color font-family">
  <div class="header-navigation-back" >
    <div class="back-icon" (click)="backAction()"><mat-icon svgIcon="left-arrow" data-testid="back-arrow-icon"></mat-icon></div>
    <div  class="header-text">Personal Documents</div>
  </div>
  <div class="content">
    <div class="documents-list-container">
      <div class="documents-list">
        <!-- Passport -->
        <div class="document-item"
             [ngClass]="passportDocument?.isPresent ? 'status-completed' : 'status-incomplete'"
             (click)="uploadFile('Passport', passportDocument?.isPresent)"
             data-testid="passport">
          <div class="document-icon-wrapper">
            <mat-icon class="document-icon passport-line" svgIcon="passport-line"></mat-icon>
          </div>
          <div class="document-info">
            <h3 class="document-title">Passport</h3>
            <p class="document-status">{{ passportDocument?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
          </div>
          <div class="status-indicator">
            <mat-icon class="status-icon">{{ passportDocument?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          </div>
        </div>

        <!-- PR Card -->
        <div class="document-item"
             [ngClass]="PRCardDocument?.isPresent ? 'status-completed' : 'status-incomplete'"
             (click)="uploadFile('PRCard', PRCardDocument?.isPresent)"
             data-testid="pr card">
          <div class="document-icon-wrapper">
            <mat-icon class="document-icon pr-visa-line" svgIcon="pr-visa-line"></mat-icon>
          </div>
          <div class="document-info">
            <h3 class="document-title">PR Card</h3>
            <p class="document-status">{{ PRCardDocument?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
          </div>
          <div class="status-indicator">
            <mat-icon class="status-icon">{{ PRCardDocument?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          </div>
        </div>

        <!-- Canada Visa (for US drivers) -->
        @if (isUSDriver) {
          <div class="document-item"
               [ngClass]="CanadianVisa?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('CanadaVisa', CanadianVisa?.isPresent)"
               data-testid="visaCanada">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon pr-visa-line" svgIcon="pr-visa-line"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">Canada Visa</h3>
              <p class="document-status">{{ CanadianVisa?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ CanadianVisa?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>
        }

        <!-- US Visa (for non-US drivers) -->
        @if (!isUSDriver) {
          <div class="document-item"
               [ngClass]="USVisa?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('USVisa', USVisa?.isPresent)"
               data-testid="visaUS">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon pr-visa-line" svgIcon="pr-visa-line"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">US Visa</h3>
              <p class="document-status">{{ USVisa?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ USVisa?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>
        }

        <!-- Work Permit -->
        <div class="document-item"
             [ngClass]="WorkPermit?.isPresent ? 'status-completed' : 'status-incomplete'"
             (click)="uploadFile('WorkPermit', WorkPermit?.isPresent)"
             data-testid="workPermit">
          <div class="document-icon-wrapper">
            <mat-icon class="document-icon bill-line" svgIcon="bill-line"></mat-icon>
          </div>
          <div class="document-info">
            <h3 class="document-title">Work Permit</h3>
            <p class="document-status">{{ WorkPermit?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
          </div>
          <div class="status-indicator">
            <mat-icon class="status-icon">{{ WorkPermit?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          </div>
        </div>

        <!-- FAST Card -->
        <div class="document-item"
             [ngClass]="fastCard?.isPresent ? 'status-completed' : 'status-incomplete'"
             (click)="uploadFile('FastCard', fastCard?.isPresent)"
             data-testid="fastCard">
          <div class="document-icon-wrapper">
            <mat-icon class="document-icon bill-line" svgIcon="bill-line"></mat-icon>
          </div>
          <div class="document-info">
            <h3 class="document-title">FAST Card</h3>
            <p class="document-status">{{ fastCard?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
          </div>
          <div class="status-indicator">
            <mat-icon class="status-icon">{{ fastCard?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          </div>
        </div>

        <!-- Health Card -->
        <div class="document-item"
             [ngClass]="healthCard?.isPresent ? 'status-completed' : 'status-incomplete'"
             (click)="uploadFile('HealthCard', healthCard?.isPresent)"
             data-testid="healthCard">
          <div class="document-icon-wrapper">
            <mat-icon class="document-icon bill-line" svgIcon="bill-line"></mat-icon>
          </div>
          <div class="document-info">
            <h3 class="document-title">Health Card</h3>
            <p class="document-status">{{ healthCard?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
          </div>
          <div class="status-indicator">
            <mat-icon class="status-icon">{{ healthCard?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          </div>
        </div>
      </div>
      <input
        mat-input
        #fileToUpload
        type="file"
        accept="application/pdf,.doc,.docx,application/msword"
        [disabled]="loading"
        (change)="onFileChange(fileToUpload)"
        class="hidden-input-field"
        />
    </div>
  </div>
</div>
